import type { QuoteRow } from "../../lib/api";
import { shortAssetId } from "../../lib/format";
import { ApyBadge } from "./ApyBadge";

export function MarketsTable({ rows }: { rows: QuoteRow[] }) {
	return (
		<div className="overflow-hidden rounded-lg border border-slate-800">
			<table className="w-full text-sm">
				<thead className="bg-slate-900/60 text-left text-xs uppercase tracking-wide text-slate-400">
					<tr>
						<th className="px-3 py-2 font-medium">#</th>
						<th className="px-3 py-2 font-medium">Asset</th>
						<th className="px-3 py-2 text-right font-medium">APY</th>
						<th className="px-3 py-2 text-right font-medium">Exit</th>
						<th className="px-3 py-2 text-right font-medium">In/Out bps</th>
					</tr>
				</thead>
				<tbody className="divide-y divide-slate-800">
					{rows.map((q, i) => (
						<tr key={`${q.provider}:${q.assetId}`}>
							<td className="px-3 py-2 font-mono text-xs text-slate-500">
								{i + 1}
							</td>
							<td className="px-3 py-2 font-mono text-xs text-slate-200">
								{shortAssetId(q.assetId, 28)}
								{q.maturity && (
									<span className="ml-2 rounded-full bg-amber-500/10 px-1.5 py-0.5 text-[10px] uppercase tracking-wide text-amber-300">
										{q.maturity.slice(0, 10)}
									</span>
								)}
								<div className="text-[10px] text-slate-500">{q.provider}</div>
							</td>
							<td className="px-3 py-2 text-right">
								<ApyBadge value={q.expectedNetApy} />
							</td>
							<td className="px-3 py-2 text-right text-slate-300">
								{q.exitTimeDays}d
							</td>
							<td className="px-3 py-2 text-right font-mono text-slate-400">
								{q.costBpsIn}/{q.costBpsOut}
							</td>
						</tr>
					))}
					{rows.length === 0 && (
						<tr>
							<td
								colSpan={5}
								className="px-3 py-4 text-center text-xs text-slate-500"
							>
								No markets match the current filter.
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
}
